module.exports = __webpack_public_path__ + "img/p20.4b4adfbb.png";